import './App.css';
import { lazy, Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, } from "react-router-dom";

import styled from "styled-components";
import Loader from './Loading';
import { MantineProvider,} from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/charts/styles.css';


const HomePage = lazy(() => import('./pages/Home'));
const ListPage = lazy(() => import('./pages/List'));
const InfoAnaliticsPage = lazy(() => import('./pages/InfoAnaliticsPage'));


const AppWrapper = styled.div`
width:100vw;
height: 100vh;
z-index: -1;
position: absolute;
`


const App = () => {
  const [loading, setLoading] = useState(true);
  const [lang, setLang] = useState("CAT");

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false)
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <MantineProvider>
      <AppWrapper id={"id_wrapper"}>
        <Router>
          {loading ? <Loader /> : (
            <Suspense fallback={<Loader />}>
              <Routes>
                <Route path="*" element={<Navigate to="/" />} />
                <Route path="/" element={<HomePage lang={lang} setLang={setLang} />} />
                <Route path="/list" element={<ListPage lang={lang} setLang={setLang} />} />
                <Route path="/analitic/:id" element={<InfoAnaliticsPage lang={lang} setLang={setLang} />} />

              </Routes>
            </Suspense>
          )}
        </Router>

        
      </AppWrapper>
    </MantineProvider>
  );
};


export default App;
